import styled from 'styled-components';
import DevicesWidth from '~/config/DevicesWidth';

// Mesma faixa âmbar nos temas claro e escuro, para o aviso sempre se destacar.
const cores = {
  fundo: '#3A2A06',
  borda: '#4F3A0C',
  fundoIcone: '#5E4512',
  destaque: '#F5C45C',
  destaqueHover: '#F8D283',
  titulo: '#FFF2D9',
  texto: '#E8D3A3',
};

export const Container = styled.section`
  flex-shrink: 0;
  width: 100%;
  background: ${cores.fundo};
  border-bottom: 1px solid ${cores.borda};
  padding: 0.75rem 1.5rem;

  .conteudo {
    max-width: 72rem;
    margin: 0 auto;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto auto;
    grid-template-areas: 'icone textos acessar fechar';
    align-items: center;
    column-gap: 1rem;
  }

  @media (max-width: ${DevicesWidth.mobileMaxWidth}px) {
    padding: 0.75rem 1rem;

    .conteudo {
      grid-template-columns: auto minmax(0, 1fr) auto;
      grid-template-areas:
        'icone textos fechar'
        '. acessar .';
      column-gap: 0.75rem;
      row-gap: 0.625rem;
      align-items: start;
    }
  }
`;

export const Icone = styled.i`
  grid-area: icone;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.375rem;
  background: ${cores.fundoIcone};
  color: ${cores.destaque};
  font-size: 1.125rem !important;
  user-select: none;
`;

export const Textos = styled.div`
  grid-area: textos;
  font-family: 'Nunito', 'cursive';
  line-height: 1.4;
  overflow-wrap: anywhere;

  .titulo {
    font-size: 0.9375rem;
    font-weight: 700;
    color: ${cores.titulo};
  }

  .texto {
    font-size: 0.8125rem;
    color: ${cores.texto};
  }
`;

export const BotaoAcessar = styled.a`
  grid-area: acessar;
  justify-self: start;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.45rem 0.9rem;
  border-radius: 0.5rem;
  background: ${cores.destaque};
  color: ${cores.fundo};
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  transition: background 0.1s;

  .material-icons {
    font-size: 1rem;
  }

  &:hover {
    background: ${cores.destaqueHover};
  }

  &:focus-visible {
    outline: 2px solid ${cores.titulo};
    outline-offset: 2px;
  }
`;

export const BotaoFechar = styled.button`
  grid-area: fechar;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 0;
  border-radius: 0.375rem;
  background: transparent;
  color: ${cores.texto};

  .material-icons {
    font-size: 1.125rem;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    color: ${cores.titulo};
  }

  &:focus-visible {
    outline: 2px solid ${cores.titulo};
    outline-offset: 2px;
  }
`;
